var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hospital-list"},[_c('h1',[_vm._v("Registered Hospital Administrators")]),_c('CDataTable',{attrs:{"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"items":_vm.getItems,"fields":_vm.fields,"items-per-page":_vm.small ? _vm.limit : 5,"pagination":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }